/**
 * Número para mostrar: coma cada mil y sin decimales cuando son solo ceros
 * ("160.00" → "160", "1234567.50" → "1,234,567.5"). Vacío si no es un número.
 *
 * Se fija `en-US` y no `es-PE` a propósito: en español CLDR no agrupa los números
 * de cuatro cifras ("1234"), y la coma de miles tiene que salir siempre.
 */
export function formatAmount(value: unknown): string {
	if (value === null || value === undefined || value === "") return "";
	const n = Number(value);
	if (Number.isNaN(n)) return `${value}`;
	return n.toLocaleString("en-US", { maximumFractionDigits: 2 });
}
